import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth-slice";
import cartReducer from "./cart-slice";
import urlReducer from "./path-slice";
import categoryReducer from "./category-slice";
import accessOrgReducer from "./accessOrg-slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    cart: cartReducer,
    path: urlReducer,
    accessOrg: accessOrgReducer,
    category: categoryReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
